import { Avatar, SxProps } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

interface UserAvatarProps {
    src?: string | null;
    size?: number;
    sx?: SxProps;
}

export function UserAvatar({ src, size = 36, sx }: UserAvatarProps) {
    return (
        <Avatar
            src={src || undefined}
            sx={{
                width: size,
                height: size,
                bgcolor: '#22222e',
                border: '1px solid rgba(255,255,255,0.1)',
                flexShrink: 0,
                ...sx,
            }}
        >
            <PersonIcon sx={{ fontSize: size * 0.58, color: 'rgba(244,244,246,0.3)' }} />
        </Avatar>
    );
}
